import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import useStyles from 'hooks/useStyles';
import useGetCurrentDevice from 'hooks/useGetCurrentDevice';
import GetFreeTrialLink from 'components/GetFreeTrialLink';

import CourseContext from '../CourseContext';
import CategoryLessons from '../CategoryLessons';
import CourseMeta from '../CourseMeta';
import TrailerLessonItem from '../TrailerLessonItem';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './CoursePlayListForFreeUser.scss';

function CoursePlayListForFreeUser() {
  useStyles(styles);

  const { isPC } = useGetCurrentDevice();
  const { t } = useTranslation(['course']);

  const { id, title, purchaseLessonList, freeLessonList } = useContext(
    CourseContext,
  );

  return (
    <div className={styles.root}>
      <TrailerLessonItem />
      <div className={styles.title}>
        <CourseMeta showClose={!isPC} />
      </div>
      <CategoryLessons
        title={t('videoplayer.videoList.sampleVideo')}
        list={freeLessonList}
      />
      <GetFreeTrialLink
        isShow={isPC}
        type="course"
        id={id}
        name={title}
        section="lesson_syllabus"
      />
      <CategoryLessons
        title={t('videoplayer.videoList.unlockVideo')}
        list={purchaseLessonList}
        size="large"
      />
    </div>
  );
}

export default CoursePlayListForFreeUser;
